import output from "_src/engine/output";

function getCoder() {
  output.error(output.DEVELOPERS_ERROR, "Can't use ZSTD encoder in the client build!");
  return null;
}

export default {getCoder};
